
  import {
    Component,
    Vue
  } from 'vue-property-decorator';
  import Navbar from './components/navbar.vue';
  import AppMain from './components/appMain.vue';
  import Sidebar from './components/sidebar.vue';

  @Component({
    components: {
      Navbar,
      AppMain,
      Sidebar
    },
  })
  export default class Layout extends Vue {
  }
